import * as React from "react";

interface FlexboxItemProps {
    alignSelf?:
        | "auto"
        | "normal"
        | "stretch"
        | "first baseline"
        | "last baseline"
        | "center"
        | "start"
        | "end"
        | "self-start"
        | "self-end"
        | "flex-start"
        | "flex-end";
    children: React.ReactChildren | React.ReactNode;
    flexShrink?: number;
    maxWidth?: number | string;
    minWidth?: number | string;
    offsetBottom?: number | string;
    offsetLeft?: number | string;
    offsetRight?: number | string;
    offsetTop?: number | string;
    width?: number | string;
}

export function FlexboxItem(props: FlexboxItemProps): JSX.Element {
    const style = {
        alignSelf: props.alignSelf,
        flexShrink: props.flexShrink,
        marginTop: props.offsetTop,
        marginLeft: props.offsetLeft,
        marginBottom: props.offsetBottom,
        marginRight: props.offsetRight,
        maxWidth: props.maxWidth,
        minWidth: props.minWidth,
        width: props.width,
    };

    return <span style={style}>{props.children}</span>;
}
